import { render, staticRenderFns } from "./CartPreview.vue?vue&type=template&id=c372fe24&scoped=true&"
import script from "./CartPreview.vue?vue&type=script&lang=ts&"
export * from "./CartPreview.vue?vue&type=script&lang=ts&"
import style0 from "./CartPreview.vue?vue&type=style&index=0&id=c372fe24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c372fe24",
  null
  
)

export default component.exports